
<template>
<div class="m-5 d-none">
    <hr style="background:#810202">
   <div class="text-center   d-flex   justify-content-center" >
    <div >
    <img src="https://4.bp.blogspot.com/-TTUIP0W36Zs/VhUOqi5JzqI/AAAAAAAAECQ/CvvFi7mv8pc/s1600/ASH-C-04.png" width="105" height="50" /> 

    </div>
    <div   :class="{'animate__animated animate__fadeIn':loader,'animate__animated animate__fadeIn':!loader}" style="   height: 50px;width:300px">
      
       <span class="shine text-center m-3" v-if="anim">{{this.$store.state.options.words[this.selectedSlide]}}</span> 
      </div>
</div> 
<hr style="background:#810202">
</div>

      
</template>
<script>
  export default {
    data() {
      return {
        sliderActive: [],
        selectedSlide: 0,
        loader: true,
        anim: true,
      }
    },
    props: {
      thumbs: {
        type: Boolean,
        default: false
      },
      autoPlay: {
        type: Boolean,
        default: true
      },
      autoPlayDelay: {
        type: Number,
        default: 5000
      },
    },
    created() {
      this.sliderActive = this.$store.state.options.words[this.selectedSlide];
      this.$emit('change', this.sliderActive)
      if (this.autoPlay) {
        setInterval(() => {
          this.changeSlide()
        }, this.autoPlayDelay);
      }

    },
    methods: {
      changeSlide(slideIndex = null) {
        this.loader = false;
        this.anim = false;
        if (slideIndex != null) {
          const slide = this.$store.state.options.words[slideIndex];
          this.selectedSlide = slideIndex;
          this.sliderActive = slide;

          setTimeout(() => {
            this.loader = true
            this.$emit('change', this.sliderActive);
          }, 400);
          
          setTimeout(() => {
            this.anim = true
          }, 100);
          return;
        }
        for (let index = 0; index < this.$store.state.options.words.length; index++) {
          const slide = this.$store.state.options.words[index];
          if (index > this.selectedSlide) {
            this.selectedSlide = index;
            this.sliderActive = slide;

            setTimeout(() => {
              this.loader = true
              this.$emit('change', this.sliderActive);
            }, 400);

            setTimeout(() => {
            this.anim = true
          }, 100);

            break;
          } 

          if(index == Number(this.$store.state.options.words.length)-1){
            this.selectedSlide = 0;
            this.sliderActive = this.$store.state.options.words[0];

            setTimeout(() => {
              this.loader = true
              this.$emit('change', this.sliderActive);
            }, 400);

            setTimeout(() => {
            this.anim = true
          }, 100);

            
          }
        }

      }
    },
  }
</script>
<style scoped>
.shine{
  font-size:30px
}
</style> 